import { createOptionsFrom } from "@/lib/common/Option";

export const PerformanceDeltaStepLabels = {
	Step24Hours: "24 Hours",
	Step3Days: "3 Days",
	Step7Days: "7 Days",
	Step14Days: "14 Days",
	Step1Month: "1 Month",
	Step3Months: "3 Months",
	Step6Months: "6 Months",
	Step1Year: "1 Year",
	Step2Year: "2 Years"
} as const;

export type PerformanceDeltaStep = keyof typeof PerformanceDeltaStepLabels;

export const PerformanceDeltaStepOptions = createOptionsFrom(PerformanceDeltaStepLabels);
